import { createSelector } from "@reduxjs/toolkit";

export const loadStart = createSelector(state => state.date, date => date.start);

export const loadEnd = createSelector(state => state.date, date => date.end);
